/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown>, name: NonNullable<unknown>, exercises: NonNullable<unknown> }} Plan_Build_Ask_Suggestions_SomeInputs */

const en_us2_plan_build_ask_suggestions_some = /** @type {(inputs: Plan_Build_Ask_Suggestions_SomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I'm building ${i?.session} (${i?.name}). It already has: ${i?.exercises}. What else could I add? Show me options to choose from.`)
};

const pt_br2_plan_build_ask_suggestions_some = /** @type {(inputs: Plan_Build_Ask_Suggestions_SomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estou montando o ${i?.session} (${i?.name}). Ele já tem: ${i?.exercises}. O que mais eu poderia adicionar? Me mostre opções para eu escolher.`)
};

const es_419_plan_build_ask_suggestions_some = /** @type {(inputs: Plan_Build_Ask_Suggestions_SomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estoy armando el ${i?.session} (${i?.name}). Ya tiene: ${i?.exercises}. ¿Qué más podría agregar? Muéstrame opciones para elegir.`)
};

const pt_pt2_plan_build_ask_suggestions_some = /** @type {(inputs: Plan_Build_Ask_Suggestions_SomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estou a montar o ${i?.session} (${i?.name}). Já tem: ${i?.exercises}. O que mais podia adicionar? Mostra-me opções para eu escolher.`)
};

const fr_fr2_plan_build_ask_suggestions_some = /** @type {(inputs: Plan_Build_Ask_Suggestions_SomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je construis ${i?.session} (${i?.name}). Elle contient déjà : ${i?.exercises}. Qu'est-ce que je pourrais ajouter ? Montre-moi des options à choisir.`)
};

const de_de2_plan_build_ask_suggestions_some = /** @type {(inputs: Plan_Build_Ask_Suggestions_SomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ich baue gerade ${i?.session} (${i?.name}). Es enthält schon: ${i?.exercises}. Was könnte ich noch hinzufügen? Zeig mir Optionen zur Auswahl.`)
};

const it_it2_plan_build_ask_suggestions_some = /** @type {(inputs: Plan_Build_Ask_Suggestions_SomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sto creando ${i?.session} (${i?.name}). Contiene già: ${i?.exercises}. Cos'altro potrei aggiungere? Mostrami delle opzioni tra cui scegliere.`)
};

/**
* | output |
* | --- |
* | "I'm building {session} ({name}). It already has: {exercises}. What else could I add? Show me options to choose from." |
*
* @param {Plan_Build_Ask_Suggestions_SomeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_ask_suggestions_some = /** @type {((inputs: Plan_Build_Ask_Suggestions_SomeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Ask_Suggestions_SomeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_ask_suggestions_some(inputs)
	if (locale === "es-419") return es_419_plan_build_ask_suggestions_some(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_ask_suggestions_some(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_ask_suggestions_some(inputs)
	if (locale === "de-DE") return de_de2_plan_build_ask_suggestions_some(inputs)
	if (locale === "it-IT") return it_it2_plan_build_ask_suggestions_some(inputs)
	return en_us2_plan_build_ask_suggestions_some(inputs)
});
export { plan_build_ask_suggestions_some as "plan-build.ask_suggestions_some" }